import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd  } from '@angular/router';
import { NgForm, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { WpService} from '../../../wp.service';


@Component({
  selector: 'app-vacunacion-antigripal',
  templateUrl: './vacunacion-antigripal.component.html',
  styleUrls: ['./vacunacion-antigripal.component.scss'],
  providers:[WpService]
})
export class VacunacionAntigripalComponent implements OnInit {
  
/*npm audit*/
  ngOnInit(): void {
  }

  @ViewChild('formident',{static: true})formident: NgForm;  
  
  
  
  apellido: any;
  nombre: any;
  correo: any;
  dni: any;  
  telefono: any;
  sede: any;
  public inscripto: any;
  
  fragment: any;
  
    constructor(private router: Router, private route: ActivatedRoute, private wpService: WpService, private http:HttpClient ){
      
      
      this.nombre = {};
      this.correo = {};
      this.dni = {};
      this.apellido = {};      
      this.telefono = {};
      this.sede = {};
      
    }
   
    
     
    
    
    submit(){
      this.apellido = this.formident.value.apellido;
      this.nombre = this.formident.value.nombre;
      this.correo = this.formident.value.correo;
      this.dni = this.formident.value.dni;      
      this.telefono = this.formident.value.telefono;
      this.sede = this.formident.value.sede;      
      let apellido = JSON.stringify(this.apellido);
      let nombre = JSON.stringify(this.nombre);
      let correo = JSON.stringify(this.correo);
      let dni = JSON.stringify(this.dni);
      let sede = JSON.stringify(this.sede);
      let telefono = JSON.stringify(this.telefono);  

      this.inscripto = [{
        "apellido" : apellido,
        "nombre" : nombre,
        "correo" : correo,
        "dni" : dni,
        "telefono" : telefono,
        "sede" : sede
      }];
    this.wpService.insertarDatos(this.inscripto).subscribe(()=>
    {      
      alert('Inscripción realizada con éxito');
    })
    this.formident.reset();
    
    }  
 

}
